import React from 'react';
import CertificationsTable from '../components/CertificateTable';

export function Certifications() {
  return <CertificationsTable />;
}
